export const AMPLITUDE_PRODUCT_CLICKED = 'product_clicked' as const;
export const AMPLITUDE_MODULE_CLICKED = 'module_click' as const;
export const AMPLITUDE_PRODUCT_FAVORITES_ADD = 'favorite_add' as const;
export const AMPLITUDE_FILTER_ADDED = 'filter_added' as const;
export const AMPLITUDE_FILTER_REMOVED = 'filter_removed' as const;

export const AMPLITUDE_PRODUCT_CLICKED_EVENT_ID = 70 as const;
export const AMPLITUDE_PRODUCT_FAVORITES_ADD_EVENT_ID = 70 as const;
export const AMPLITUDE_FILTER_EVENT_ID = 7 as const;

export const GTM_EVENT_KEY = 'gtm.uniqueEventId' as const;

// Screen types for Amplitude tracking - different from Amethyst PAGE_TYPE_MAP
export const AMPLITUDE_SCREEN_TYPES = {
  SEARCH_PAGE: 'plp'
} as const;
